import { render, staticRenderFns } from "./trans-basic-info.html?vue&type=template&id=104e3d4a&scoped=true&external"
import script from "./trans-basic-info.js?vue&type=script&lang=js&external"
export * from "./trans-basic-info.js?vue&type=script&lang=js&external"
import style0 from "./trans-basic-info.scss?vue&type=style&index=0&id=104e3d4a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104e3d4a",
  null
  
)

export default component.exports